/**
 * Function which takes the current pathname and removes everything
 * after the last `/`.
 *
 * @param {string} pathname - From window.location.pathname.
 * @param {number} count - (Optional) The number of path segments to remove. If this number is more than the number of segments,
 *                         we return an empty string.
 * @example
 * stripLastPathSegment('/issues/quality/123'); // => `/issues/quality`
 * stripLastPathSegment('/projects/:projectId/refs/branch/main/issues/quality/123'); // => `/projects/:projectId/refs/branch/main/issues/quality`
 */
export const stripLastPathSegment = (pathname: string, count: number = 1): string => pathname
  .split('/') // Split into array of path parts.
  .slice(0, -count) // Remove the last part of the path.
  .join('/'); // Join them back to a string.
